<template>
  <div class="contract-list">
    <div class="nav">
      <el-form :model="form" label-width="80px" :inline="true"  class="demo-form-inline flex1">
        <el-form-item label="合同编号:">
          <el-input v-model="form.number" size="mini" placeholder="请输入合同编号"></el-input>
        </el-form-item>
        <el-form-item label="签订单位:">
          <el-input v-model="form.company" size="mini" placeholder="请输入合同签订公司"></el-input>
        </el-form-item>
        <el-form-item label="合同类型:">
          <el-select v-model="form.type" size="mini" filterable placeholder="全部">
            <el-option v-for="(item,index) in contactTypeList" :label="item.typeName" :value="item.typeName" :key="`${index}a`"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同名称:">
          <el-input v-model="form.name" size="mini" placeholder="请输入合同名称"></el-input>
        </el-form-item>


<!--        <el-form-item label="客户合同编号:" label-width="100px">-->
<!--          <el-input v-model="form.customerNumber" size="mini" placeholder="请输入客户合同编号"></el-input>-->
<!--        </el-form-item>-->

<!--        <el-form-item label="签订时间:">-->
<!--          <el-date-picker-->
<!--            v-model="form.time"-->
<!--            type="date"-->
<!--            size="mini"-->
<!--            placeholder="请选择合同签订时间"-->
<!--            value-format="yyyy-MM-dd">-->
<!--          </el-date-picker>-->
<!--        </el-form-item>-->
        <el-form-item label="合同状态:">

          <el-select v-model="form.status" size="mini" filterable placeholder="全部">
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已通过" value="2"></el-option>
            <el-option label="未通过" value="3"></el-option>
            <el-option label="已取消" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
        >
          <el-table-column label="序号" align="center" width="50px" type="index" :index="(index)=>{return  this.form.rows * (this.form.page - 1) + index + 1;}">
          </el-table-column>
          <el-table-column prop="codeNumber" label="合同编号" width=100 align="center"/>
          <el-table-column prop="companyType" label="单位类型" width="100" align="center">
            <template slot-scope="scope" >{{scope.row.companyType |companyTypeFormat}}</template>
          </el-table-column>
          <el-table-column prop="companyName" label="签订单位" width="199" align="center">
            <template slot-scope="scope">
              <div style="height: 18px;">
                {{scope.row.companyName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="contractName" label="合同名称" align="center"/>
          <el-table-column prop="typeName" label="合同类型" align="center"/>

          <el-table-column prop="addPeopleName" label="承办人" align="center"></el-table-column>
          <el-table-column prop="createTime" label="签记时间" align="center" width="150">
            <template slot-scope="scope">
              {{scope.row.createTime |formatTime}}
            </template>
          </el-table-column>
          <el-table-column prop="validityStart" label="有效期" align="center" width="180">
            <template slot-scope="scope">
              {{scope.row.startDate |validityDady}}--{{scope.row.endDate |validityDady}}
            </template>
          </el-table-column>
<!--          <el-table-column prop="name" label="签订总价格" align="center"/>-->
<!--          <el-table-column prop="nameTell" label="签订时间" align="center"/>-->
<!--          <el-table-column prop="state" label="合同起始时间" align="center"/>-->
          <el-table-column prop="examine" label="审核状态" align="center" width="100%">
            <div slot-scope="scope">{{getState(scope.row.examine,scope.row.operationPower)}}</div>
          </el-table-column>
          <el-table-column prop="examine" label="操作类型" align="center" width="100%">
            <div slot-scope="scope">{{operationTypeFormat(scope.row.operationType)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id,scope.row.operationPower)">详情</el-button>
                <el-button v-if="scope.row.examine===1 && scope.row.operationPower===1" size="mini" type="primary" @click="passClick(scope.row.id)" >通过</el-button>
                <el-button v-if="scope.row.examine===1 && scope.row.operationPower===1" size="mini" type="danger" @click="rejectClick(scope.row.id)">驳回</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows"
        />
      </div>
    </div>

    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='623px' center @close="Reject">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p>{{detailData.state}}</p>
          </div>
          <div class="baseInfoContent">
            <el-form :model="detailData"  label-position="left">
              <el-form-item label="合同编号:">
                <span>{{detailData.codeNumber}}</span>
              </el-form-item>
              <el-form-item label="签约单位:">
                <span>{{detailData.companyName}}</span>
              </el-form-item>
              <el-form-item label="合同名称:">
                <span>{{detailData.contractName}}</span>
              </el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同类型:">
                    <span>{{detailData.typeName}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="紧急程度:">
                    <span>{{detailData.urgent |urgentFormat}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="年度表总额:">
                    <div class="center-f">{{detailData.totalYearName}}</div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="有效期:">
                    <div class="center-f">{{detailData.startDate |validityDady}}--{{detailData.endDate |validityDady}}</div>
                  </el-form-item>
                </el-col>
              </el-row>


              <el-form-item label="主要内容:">

                <div class="center-f">{{detailData.content}}</div>
              </el-form-item>



            </el-form>
          </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>附件信息</span>
          </div>
          <div class="baseInfoContent" style="padding: 0 23px 10px 23px;">
            <div style="display: flex;width: 100%" v-if="detailData.img && detailData.img.length > 0">
              <el-form :model="detailData" label-position="left" style="width: 100%">
                <span style="font-weight: 700;margin: 10px 10px;cursor: pointer;display: block;width: 150px;text-decoration: underline">查看附件人</span>
                <el-row :gutter="10" style="width: 100%" v-for="(item,index) in detailData.img" :key="`${index}cvg`">
                  <el-col :span="13" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{item.name}}</el-col>
                  <el-col :span="7">{{item.uploadTime}}</el-col>
                  <el-col :span="2">
                    <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item,index)"
                       v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg'
                             ||item.name.substring(item.name.indexOf('.')) == '.png'
                             ||item.name.substring(item.name.indexOf('.')) == '.jpg'
                             || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>

                  </el-col>
                  <el-col :span="2">
                    <i class="el-icon-download" @click="downloadClick(item.id)"></i>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div v-else style="font-weight: 700;margin: 10px 10px;cursor: pointer;display: block;width: 150px;">暂无附件</div>
          </div>

        </div>
        <div class="operation" v-if="detailData.margin&&detailData.marginType">
          <div class="operationTitle">
            <div class="line"/>
            <span>履约保证金</span>
          </div>
          <!--            :icon="activity.icon"-->
          <div class="baseInfoContent" >
            <el-form :model="detailData"  label-position="left">
              <el-form-item label="履约保证金金额:">
                {{detailData.margin}}
              </el-form-item>
              <el-form-item label="缴纳方式:">
                {{detailData.marginType}}
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>其他信息</span>
          </div>
          <div class="baseInfoContent">
            <el-form :model="detailData"  label-position="left">

              <el-row>
                <el-col :span="12">
                  <el-form-item label="承办人:">
                    <span>{{detailData.addPeopleName}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="登记时间:">
                    <span>{{detailData.createTime |formatTime}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="签约日期:">
                    <div class="center-f">{{detailData.createTime |formatTime}}</div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="办理完结时间:">
                <div class="center-f">{{detailData.overTime}}</div>
              </el-form-item>
            </el-form>
          </div>
        </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>审核信息</span>
            </div>
            <div class="operationTable">
              <steps :step-data="stepData" :step-state="stepState"/>
            </div>
          </div>
          <div class="operation" v-if="detailData.operationPower===1 && detailData.examine===1">
            <div class="operationTitle">
              <div class="line"/>
              <span>操作</span>
            </div>
            <div class="operationTable">
              <el-form :model="detailData" label-width="60px" :rules="rules" ref="detailRef">
                <el-form-item label="原因"  prop="reason">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 8}"
                    placeholder="请填写同意/拒绝原因"
                    v-model="detailData.reason" size="mini" style="width: 85%">
                  </el-input>
                </el-form-item>
              </el-form>

            </div>

          </div>
            <div class="btnContainer" v-if="detailData.operationPower===1 && detailData.examine===1">
              <el-button class="searchBtn" size="medium" @click="agree">同意</el-button>
              <el-button class="resetBtn" size="medium" @click="Reject">拒绝</el-button>
            </div>
        </div>

      </div>

    </el-dialog>
  </div>
</template>

<script>
  import steps from "@/components/steps";
  import {formatTime, getSessionStore} from "@/config/mUtils";
  import {
    contractAffairsExaminePpageList,
    contractAffairsExamineDetail,
  } from "@/service/audit"
  import {contractTypeSelectList} from "@/service/contract";
  import {baseImgUrl, baseUrl} from "@/config/env";
  export default {
    components: {
      steps,
    },

    data() {
      return {
        form:{
          name:"",
          type:"",
          number:"",
          customerNumber:"",
          company:"",
          time:"",
          status:"",
          page:1,
          rows:10,

        },
        total:0,
        tableLoad:false,
        TableDatas:[
          ],

        detailDialogVisible:false,
        detailData:{
        },
        contactTypeList:"",//合同类型列表
        operationData:[

        ],
        stepData:[
          {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
          {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
          {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
          {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        ],
        dialogTitle:'',
        DialogVisible:false,
        addflag:false,
        rules:{
          reason:{ required: true, message: '请填写同意/拒绝原因', trigger: 'blur' },
        },

      };

    },
    filters:{
      formatTime(val){
        if(val){
          return formatTime(val, "yyyy-mm-dd hh:ii:ss")
        }else {
          return ''
        }

      },
      validityDady(val){
        if(val){
          return formatTime(val, "yyyy-mm-dd")
        }else {
          return ''
        }
      },
      companyTypeFormat(value){
        switch (value) {
          case 1:
            return "委托商";
          case 2:
            return "公路供应商";
          case 3:
            return "水路供应商";
          case 4:
            return "港口及其他";
        }
      },
      urgentFormat(val){
        switch (val) {
          case 1:
            return '紧急';
          case 2:
            return '急';
          case 3:
            return '一般';
        }
      },
    },
    computed:{
      stepState(){
        return function(state){
          switch(state) {
            case '':
              return 'wait'
            case 'success':
              return 'success'
            case 'failure':
              return 'error'
          }
        };
      },
      // 审核状态
      getState(){
        return function(state,operationPower){
          switch(true) {
            case operationPower ===0:
              return '已通过'
            case state ===1 &&operationPower ===1:
              return '待审核'
            case state ===2 &&operationPower ===1:
              return '已通过'
            case state ===3 &&operationPower ===1:
              return '已拒绝'
            case state ===4 &&operationPower ===1:
              return '已取消'
          }
        };
      },
      //操作类型
      operationTypeFormat(){
        return function (value) {
          switch(value) {
            case 1:
              return '新增'
            case 2:
              return '信息变更'
            case 3:
              return '终止合作'
          }
        }
      },
    },
    mounted(){
      this._contractAffairsExaminePpageList();
      this._contractTypeSelectList();
    },
    methods: {
      /**
       * 分页查询
       * @returns {Promise<ElMessageComponent>}
       * @private
       */
      async _contractAffairsExaminePpageList(){
        let {number,company,type,name,status,page,rows} =this.form
        let data={
          codeNumber: number,  // 合同编号
          companyName: company,  // 签约单位
          typeName: type,  // 合同类型
          contractName: name,  // 合同名称
          // addPeopleName: '',   // 承办人
          examine: status,  // 状态
          page:page,
          rows:rows,
        }
        this.tableLoad = true
        let res =await contractAffairsExaminePpageList(data)
        this.tableLoad = false
        if (res.status !==0)  return this.$message.error(res.message)
        this.TableDatas = res.data.records
        this.total = res.data.total

      },
      async _contractTypeSelectList(){
        let res =await  contractTypeSelectList({contractTypeName:''})
        if (res.status !==0) return this.$message.error(res.message)
        this.contactTypeList = res.data.map((item)=>{
          return{
            typeName:item.contract_name,
            typeId:item.id
          }
        })
      },
      searchBtn(){
        this.form.page = 1;
        this._contractAffairsExaminePpageList()
      },
      resetBtn(){
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = ""
        }
        this.form.page = 1
        this.form.rows = 10

      },
      addBtn(){
        this.addflag = true
      },
      contractSizeChange(row){
        this.form.rows=row;
        this._contractAffairsExaminePpageList()
      },
      contractCurrentChange(page){
        this.page=page;
        this._contractAffairsExaminePpageList()
      },
      // 详情
      async detailClick(id,operationPower){
        this.detailDialogVisible = true
        let res =await contractAffairsExamineDetail(id)
        if (res.status !==0) return this.$message.error(res.message)
        let array = res.data.attachmentList.map(item=>{
          return {
            name:item.attachmentName,
            url:this.baseImgUrl + item.attachmentGroup+ "/" + item.attachmentPath,
            status:'success',
            id:item.id,
            uploadTime:item.uploadTime
          }
        })
        this.detailData = {
          ...res.data,
          img:array,
          reason:"",
          operationPower:operationPower
        }
      },
      passClick(id){
        this.$prompt('确认同意当前合同申请吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: "textarea",
          inputValidator: function (value) {
            if (!value) {
              return false;
            }
          },
          inputErrorMessage: "同意原因不能为空",
          inputPlaceholder:'请输入同意原因',
          type: 'warning'
        }).then(async ({value}) => {
        }).catch(() => {});
      },
      rejectClick(id){
        this.$prompt('确认拒绝当前合同申请吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: "textarea",
          inputValidator: function (value) {
            if (!value) {
              return false;
            }
          },
          inputErrorMessage: "拒绝原因不能为空",
          inputPlaceholder:'请输入拒绝原因',
          type: 'warning'
        }).then(async ({value}) => {
        }).catch(() => {});
      },
      //详情同意
      agree(){
        this.$refs.detailRef.validate(async (valid) => {
          if (valid){

          }else {
            this.$message.warning("请填写信息")
          }
        })
      },
      //详情拒绝
      Reject(){
        this.detailDialogVisible = false
        this.$refs.detailRef.resetFields();
      },
      /**
       * 详情附件查看
       * @param item 图片对象
       * @param index
       */
      handlePictureCardPreview(item,index){
        let token = getSessionStore('token');
        this.dialogImageUrl = baseImgUrl + "/web/attachmentFtp/download?attachmentId="+(item.id||item.response.data.id)+"&access_token="+token;
        this.dialogVisible = true;
      },
      //详情附件下载
      downloadClick(id){
        let token = getSessionStore('token')
        window.location.href = baseUrl + "/web/attachmentFtp/download?attachmentId="+ id +"&access_token="+
          token
      },
    },
  };
</script>



<style lang="scss" scoped>
  .contract-list{
    /*width:100%;*/
    padding:20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav{
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;
      .flex1{
        flex: 1;
      }
      .el-input{
        width: 150px;
      }
      .el-select{
        width: 150px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    ::v-deep .detail{
      .el-form-item__label{
        font-weight: 700;
      }
      .line{
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }
      .line +span{
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }
      width: 100%;
      padding: 10px 0 20px 20px;
      .baseInfo{
        display: flex;
        flex-direction: column;

        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }
        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          padding:20px 23px 0 23px;
          font-size: 14px;
          .center-f{
            display: flex;
          }
          .el-form-item{
            margin-bottom: 2px;

          }

          /*&Item{*/
          /*  margin-bottom: 20px;*/
          /*  span{*/
          /*    color: rgba(16, 16, 16, 100);*/
          /*    font-size: 14px;*/
          /*  }*/
          /*  .specialOne{*/
          /*    width:50%;*/
          /*  }*/
          /*}*/
          /*.specialItem{*/
          /*  display:flex;*/
          /*}*/
        }
      }
      .operation{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Table{
          width:100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
      .btnContainer{
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;
        button{
          margin: 0 15px;
        }
      }
    }
  }
  ::v-deep{

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 75vh;
      color: #606266;
    }

  }
</style>
